<template>
  <section class="bg-hero-image h-big">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative">
      <!-- Hero content -->
      <div class="relative pt-40 hero-content">
        <div class="max-w-3xl mx-auto text-center pb-40 sm:pb-12">
          <h1 class="h1 text-4xl text-white font-message pl-4" data-aos="fade-up">健康な生涯現役を。</h1>
        </div>
        <div class="max-w-3xl mx-auto text-center pb-12 mt-12 md:pb-16">
          <a
            class="absolute inset-x-0 mx-auto flex p-4 bg-white hover:bg-gray-100 button"
            data-aos="fade-up"
            @click.prevent.stop="videoModalOpen = true"
            aria-controls="modal"
          >
            <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
            <span class="block font-bold text-theme-900">まずはここを強くクリック</span>
          </a>
        </div>

        <Modal id="modal" ariaLabel="modal-headline" :show="videoModalOpen" @handleClose="videoModalOpen = false">
          <div class="relative pb-9/16">
            <iframe
              class="absolute w-full h-full"
              src="https://www.youtube.com/embed/UKTIvLI0Gs8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </Modal>
      </div>
    </div>
  </section>
</template>

<script>
import Modal from "./../utils/Modal.vue"

export default {
  name: "HeroHome",
  components: {
    Modal,
  },
  data: function() {
    return {
      videoModalOpen: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.bg-hero-image {
  background-image: url("./../images/hero-background-m.jpg");
  background-size: cover;
  background-position: center;

  @screen sm {
    background-image: url("./../images/hero-background.jpg");
    .relative {
      .hero-content {
        padding-top: 18rem;
      }
    }
  }
}
.pt-72 {
  padding-top: 18rem;
}
.button {
  width: 250px;
  cursor: pointer;
}
</style>
